import { render, staticRenderFns } from "./RuleCustomListMcx.vue?vue&type=template&id=796ce677&scoped=true"
import script from "./RuleCustomListMcx.vue?vue&type=script&lang=js"
export * from "./RuleCustomListMcx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ce677",
  null
  
)

export default component.exports